import { Component, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { CommonService } from 'src/app/services/common.service';
import { ReportsService, NavigationFilter } from 'src/app/services/reports.service';

interface ManualSubscriptions {
  commonReportChanged: Subscription;
  pageChanged: Subscription;
  driverPerformanceDialogClosed: Subscription;
}

@Component({
  selector: 'report-data-multi-nav',
  templateUrl: './report-data-multi-nav.component.html',
  styleUrls: ['./report-data-multi-nav.component.scss'],
})
export class ReportDataMultiNavComponent implements OnDestroy {
  manualSubscriptions: ManualSubscriptions = {
    commonReportChanged: null,
    pageChanged: null,
    driverPerformanceDialogClosed: null,
  };
  dataNavVisible: boolean;
  navigationFilters: [NavigationFilter];

  constructor(private rptService: ReportsService, public cService: CommonService) {
    this.manualSubscriptions.commonReportChanged = this.rptService.commonReportDataChanged$.subscribe({
      next: (reportMeta) => this.init(),
    });

    this.manualSubscriptions.driverPerformanceDialogClosed = this.rptService.driverPerformanceDialogClosed$.subscribe({
      next: () => this.init(),
    });
  }

  private init() {
    this.dataNavVisible = false;
    if (
      this.rptService.currentReportMeta &&
      this.rptService.currentReportMeta.navigationFilters &&
      this.rptService.currentReportMeta.navigationFilters.length > 0
    ) {
      this.navigationFilters = this.rptService.currentReportMeta.navigationFilters;
      this.navigationFilters.map((filter) => (filter.selected = filter.selected ? filter.selected : filter.options[0]));
      this.dataNavVisible = true;
    }
  }

  public dataFilterChanged(selectedNavigationFilter, optionSelected: any) {
    selectedNavigationFilter.selected = optionSelected;
    this.applySelectedFilter();
  }

  private applySelectedFilter() {
    for (const navigationFilter of this.navigationFilters) {
      this.rptService.requestedServerFilters[navigationFilter.name] = navigationFilter.selected.value;
    }
    this.rptService.triggerServerFilterChangedObservable(true);
  }

  ngOnDestroy() {
    for (const sub in this.manualSubscriptions) {
      if (this.manualSubscriptions[sub]) {
        this.manualSubscriptions[sub].unsubscribe();
      }
    }
  }
}
